export class OrgUnitFieldParameter {
  // no definition. the field contains always the own org unit. it is required to be located in one to use rbb forms.

}
